import * as React from 'react';
export const visaSvg = React.forwardRef(function visaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E6EBF1',
        fillRule: 'nonzero',
        d: 'M1 12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v8Zm-1 0V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#1434CB',
        d: 'M0 5V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1H0Zm5 2h6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F7B600',
        d: 'M0 11v1a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-1H0Z',
      }),
    ),
  );
});
visaSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var visa = {
  category: 'card',
  colorable: false,
  name: 'visa',
  svg: visaSvg,
};
